import React from 'react'
import {Modal} from '@therms/atalaya'
import {NewReportStepper} from '@src/modules/Reports/shared/NewReport/NewReportStepper'
import {REPORTS_ROUTES} from '@src/modules/Reports/constants'
import {generatePath, useHistory} from 'react-router-dom'

interface NewReportModalProps {
  closeHandler: () => void
}

function NewReportModal({closeHandler}: NewReportModalProps) {
  const history = useHistory()

  return (
    <Modal closeHandler={closeHandler} escPressClose header="New Report">
      <NewReportStepper
        onReportCreated={({reportId}) =>
          history.push(generatePath(REPORTS_ROUTES.VIEW_REPORT, {reportId}))
        }
      />
    </Modal>
  )
}

export {NewReportModal}
